// wijmo
/* eslint-disable react-hooks/exhaustive-deps */
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Form, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
// import NumberInput from "../../../components/InputWrapper/NumberInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { e点検整備区分 } from "../../../constant/enum/syaryo"
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import TenkenService from "../../../service/truck/tenken/tenkenService"
import {
  TTenkenSeibiListGetReq,
  TTenkenSeibiListGetRes,
  TSyaryoTenkenList,
} from "../../../service/truck/tenken/TTenken"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoCellTemplateContext, TWijmoComboBox } from "../../../type/wijmoComponents"
import { e記号 } from "../../../constant/enum/frontend"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import { e支払先区分 } from "../../../constant/enum/master"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import TenkenSeibiListModal from "./TenkenSeibiListModal"
import { FunctionContext } from "../../../components/Context"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { tenkenseibiExcelFormat, tenkenseibiPdfFormat } from "../../../ts/util/haisyaUtil"
import { 区分分類コード } from "../../../constant/enum/codes"
import util from "../../../ts/util"
import { メニューコード } from "../../../constant/menuCode"
import { create予定月フラグ } from "./tenkenSeibiUtil"

// #region [type]

type MonthNumber = `${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}`

export type T点検整備Item = TTenkenSeibiListGetRes &
  Partial<{
    登録番号?: string
    予定月_1?: string
    予定月_2?: string
    予定月_3?: string
    予定月_4?: string
    予定月_5?: string
    予定月_6?: string
    予定月_7?: string
    予定月_8?: string
    予定月_9?: string
    予定月_10?: string
    予定月_11?: string
    予定月_12?: string
    実績月_1?: string
    実績月_2?: string
    実績月_3?: string
    実績月_4?: string
    実績月_5?: string
    実績月_6?: string
    実績月_7?: string
    実績月_8?: string
    実績月_9?: string
    実績月_10?: string
    実績月_11?: string
    実績月_12?: string
  }> &
  Partial<{
    [key in `初期表示用予定点検整備区分コード_${MonthNumber}`]?: string
  }>

// DefaultCombo
export type T原動機 = { name: string; value: any }
export type TItem = { name: string; value: any }

//#endregion

// #region ComboBoxDummy

// defaultComboBox用
const boolList: T原動機[] = [
  {
    name: "なし",
    value: 0,
  },
  {
    name: "あり",
    value: 1,
  },
]
// #endregion

/**
 * 点検整備一覧
 * @returns
 */
const TenkenSeibiList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)
  const loginUser = useSelector((state: RootState) => state.user.LoginUserInfo)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)
  const ref年度 = useRef<number>(parseInt(dayjs(eigyobi).format("YYYY")))

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "TenkenSeibiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T点検整備Item>, pageSize: number) => {
    // 日付Column設定用のリスト
    let 予定日付リスト: any = {}
    let 実績日付リスト: any = {}
    let 初期表示用予定点検整備区分コードリスト: any = {}
    // Column作成リスト
    let 月List: any = []
    // 12ヵ月
    let cnt = 12
    // Columnリストへ作成する月を格納
    for (let k = 1; k < cnt + 1; k++) {
      月List.push(k)
    }

    // 予定用リストの作成
    月List.forEach((element: any) => {
      // Bind名を動的に生成し、所定の条件で表示値を設定する
      予定日付リスト[`予定月_${element}`] = (i: T点検整備Item) => {
        // 作成中のColumnに紐づけされる日付を生成
        const month = element
        const ret = ("00" + month).slice(-2) // 0埋め

        // 検索時にValidationでstateの年をチェックしているので存在する前提でセット
        let year = 年!.toString()

        // 現在Columnの紐づく日付
        const colDate = year + "/" + ret

        const {
          // ３か月点検の予定フラグ
          予定月,
          // 年次の車検予定フラグ
          予定車検月,
        } = create予定月フラグ(i, element, colDate)

        // 自主点検予定表示用
        const 予備車フラグ = i.予備車フラグ

        let targetList = i.点検整備リスト.filter((d) => dayjs(d.点検整備予定日).format("YYYY/MM") === colDate)

        // TODO: データが存在する場合、点検区分を確認し、以下のように対応
        // 車輌点検区分あり ⇒ 車輌点検区分を優先表示
        // 車輌点検区分なし ⇒
        let kigoListSyaken: Array<string> = []
        let kigoListTenken: Array<string> = []
        let kigoListZiko: Array<string> = []
        let kigoListSeibi: Array<string> = []
        let kigoListJishuTenken: Array<string> = []
        targetList.forEach((d) => {
          if (d.車輌点検整備区分コード === e点検整備区分.法令点検_車検) {
            const kigo = 点検整備区分ItemSource?.filter((m) => m.区分コード === d.車輌点検整備区分コード)
            if (kigo) {
              kigoListSyaken.push(kigo[0].名称2)
            }
          } else if (d.車輌点検整備区分コード === e点検整備区分.法令点検_３ヶ月) {
            const kigo = 点検整備区分ItemSource?.filter((m) => m.区分コード === d.車輌点検整備区分コード)
            if (kigo) {
              kigoListTenken.push(kigo[0].名称2)
            }
          } else if (d.車輌点検整備区分コード === e点検整備区分.整備) {
            const kigo = 点検整備区分ItemSource?.filter((m) => m.区分コード === d.車輌点検整備区分コード)
            if (kigo) {
              kigoListSeibi.push(kigo[0].名称2)
            }
          } else if (d.車輌点検整備区分コード === e点検整備区分.事故修繕) {
            const kigo = 点検整備区分ItemSource?.filter((m) => m.区分コード === d.車輌点検整備区分コード)
            if (kigo) {
              kigoListZiko.push(kigo[0].名称2)
            }
          } else if (d.車輌点検整備区分コード === e点検整備区分.自主点検) {
            const kigo = 点検整備区分ItemSource?.filter((m) => m.区分コード === d.車輌点検整備区分コード)
            if (kigo) {
              kigoListJishuTenken.push(kigo[0].名称2)
            }
          }
        })

        // 区分データなしの場合のエラー回避
        if (!点検整備区分ItemSource) return ""

        // 点検整備データに紐づく記号リストを表示させる
        // ※ 車検関係の整備区分データが存在しない場合かつ、予定月の場合は白抜き記号（予定記号）を必ず表示する
        let kigoList: Array<string> = []

        // 車検or３か月点検の候補月の場合、同整備区分データが存在確認して記号を表示に含める
        if (kigoListTenken.length === 0 && 予定月 === true) {
          // 3ヵ月点検データ無しで、予定月の場合「〇」を表示に含める
          kigoList.push(e記号.丸)
        } else if (kigoListTenken.length === 0 && 予定車検月 === true) {
          // 車検データ無しで、車検予定月の場合「☆」を表示に含める
          kigoList.push(e記号.星)
        }

        // 各整備区分の記号リストの記号を表示用リストにまとめる
        kigoListSyaken.forEach((d) => {
          kigoList.push(d)
        })
        kigoListTenken.forEach((d) => {
          kigoList.push(d)
        })
        kigoListSeibi.forEach((d) => {
          kigoList.push(d)
        })
        kigoListZiko.forEach((d) => {
          kigoList.push(d)
        })
        kigoListJishuTenken.forEach((d) => {
          kigoList.push(d)
        })
        // 予備車フラグONの場合、自主点検予定「▽」を毎月表示する
        if (kigoListJishuTenken.length === 0 && 予備車フラグ === 1) {
          kigoList.push(e記号.下三角)
        }

        // 区切り文字を設定して返却
        return kigoList.join()
      }

      // 実績用リストの作成
      // Bind名を動的に生成し、所定の条件で表示値を設定する
      実績日付リスト[`実績月_${element}`] = (i: T点検整備Item) => {
        // 作成するColumnに紐づく日付データがある場合、targetに設定する
        const target = i.点検整備リスト.find((item) => {
          let m = parseInt(dayjs(item.点検整備実施日).format("MM"))

          return element === m
        })
        // 対象Columnに対応した年月項目が存在しない場合、空で返却
        if (!target) return ""

        // 比較用のmonth項目を設定
        let month = element
        let ret = ("00" + month).slice(-2) // 0埋め
        let year

        // TODO:年を削除した際にNanになるため、どうエラー通知するか？
        //  ⇒SeachValidation入れたので不要なら削除
        // 年のstate変数が設定されているか判定
        if (年 !== undefined && !isNaN(年)) {
          year = 年.toString()
        }

        // 現在Columnの紐づく日付
        let tmpDate = year + "/" + ret

        // 対象の点検整備データから紐づく年月項目を判定し、表示記号を返却する
        if (dayjs(target.点検整備実施日).format("YYYY/MM") === tmpDate) {
          return dayjs(target.点検整備実施日).format("MM/DD")
        } else {
          return ""
        }
      }

      // 点検整備区分の新規追加の際に初期値を設定するため、
      // 予定を確認し、優先度に合わせてマークを設定する。
      初期表示用予定点検整備区分コードリスト[`初期表示用予定点検整備区分コード_${element}`] = (i: T点検整備Item) => {
        let 初期表示用予定点検整備区分コード: string = ""

        // 作成中のColumnに紐づけされる日付を生成
        const month = element
        const ret = ("00" + month).slice(-2) // 0埋め

        // 検索時にValidationでstateの年をチェックしているので存在する前提でセット
        let year = 年!.toString()

        // 現在Columnの紐づく日付
        const colDate = year + "/" + ret

        const {
          // ３か月点検の予定フラグ
          予定月,
          // 年次の車検予定フラグ
          予定車検月,
        } = create予定月フラグ(i, element, colDate)

        let targetList = i.点検整備リスト.filter((d) => dayjs(d.点検整備予定日).format("YYYY/MM") === colDate)

        // 設定中のColumnに紐づく点検整備データが存在しないかつ、予定月である場合に所定の記号を返却
        // 予定月の判定
        let 法令３ヶ月点検存在フラグ: boolean = false
        targetList.forEach((d) => {
          if (!法令３ヶ月点検存在フラグ && d.車輌点検整備区分コード === e点検整備区分.法令点検_３ヶ月) {
            法令３ヶ月点検存在フラグ = true
          }
          if (
            wjCore.isNullOrWhiteSpace(初期表示用予定点検整備区分コード) ||
            Number(初期表示用予定点検整備区分コード) > Number(d.車輌点検整備区分コード)
          ) {
            // 表示順は区分コードの昇順で表示するため、初期表示用予定点検整備区分コードを設定
            // 具体的には 車検 > ３か月点検 > 整備 > 事故修繕 > 自主点検 の順で表示する
            初期表示用予定点検整備区分コード = d.車輌点検整備区分コード
          }
        })

        // 車検or３か月点検の候補月の場合、同整備区分データが存在確認して記号を表示に含める
        if (!法令３ヶ月点検存在フラグ && 予定月 === true) {
          if (
            wjCore.isNullOrWhiteSpace(初期表示用予定点検整備区分コード) ||
            Number(初期表示用予定点検整備区分コード) > Number(e点検整備区分.法令点検_３ヶ月)
          ) {
            初期表示用予定点検整備区分コード = e点検整備区分.法令点検_３ヶ月
          }
        } else if (!法令３ヶ月点検存在フラグ && 予定車検月 === true) {
          if (
            wjCore.isNullOrWhiteSpace(初期表示用予定点検整備区分コード) ||
            Number(初期表示用予定点検整備区分コード) > Number(e点検整備区分.法令点検_車検)
          ) {
            初期表示用予定点検整備区分コード = e点検整備区分.法令点検_車検
          }
        }
        // 現状の初期表示では車検と３か月点検以外は初期設定しない
        if (
          初期表示用予定点検整備区分コード === e点検整備区分.法令点検_車検 ||
          初期表示用予定点検整備区分コード === e点検整備区分.法令点検_３ヶ月
        ) {
          return 初期表示用予定点検整備区分コード
        } else {
          return ""
        }
      }
    })

    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        sort_車番: (i: T点検整備Item) => commonUtil.createSortString(i.車番, VALIDATE_CONSTANT.LENGTH.車番),

        ...予定日付リスト,
        ...実績日付リスト,
        ...初期表示用予定点検整備区分コードリスト,
        //#endregion
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 桁数を返す関数
   * @param num
   * @returns
   */
  const numDigits = (num: number) => {
    return num.toString().length
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    if (年 == null) {
      messages.push(`年 を入力してください。`)
      hasError = true
    }
    // NaNチェック
    else if (isNaN(年)) {
      messages.push(`数値 を入力してください。`)
      hasError = true
    } else {
      const num = numDigits(年)
      if (4 !== num) {
        messages.push(`年数は YYYY の形式で入力してください。`)
        hasError = true
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TTenkenSeibiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    flexGrid?.select(-1, -1) // カレンダー部分のselectEvent回避の為のおまじない

    let currentSearchCondition: TTenkenSeibiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(createDisplaySearchCondition(currentSearchCondition))

    try {
      const res = await new TenkenService().getList(currentSearchCondition)
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      ref年度.current = currentSearchCondition.年!
      // setAccordionController(false)
    } catch (error) {
      disPatch(setAlerts(error))
      // dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TTenkenSeibiListGetReq = queryString.parse(location.search)
    if (query.年 != null) {
      let new年: number

      if (typeof query.年 === "string") {
        new年 = parseInt(query.年)
      } else {
        new年 = query.年
      }

      set年(new年)
    }

    set点検整備区分コード(query.点検整備区分コードList != null ? "1" : undefined)
    set部所コード(query.部所コード)
    set原動機コード(query.原動機有無フラグ)
    set車番(query.車番)
    setメーカーコード(query.メーカー)
    set車台番号(query.車台番号)
    set廃車予定フラグ(query.廃車予定フラグ != null ? query.廃車予定フラグ.toString() : null)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTenkenSeibiListGetReq => {
    return {
      年月: dayjs().year(年!).startOf("year").format("YYYY/MM/DD"),
      年,
      点検整備区分コードList:
        点検整備区分コード === "1" ? [e点検整備区分.法令点検_車検, e点検整備区分.法令点検_３ヶ月] : undefined,
      部所コード: 部所コード ?? undefined,
      車番: 車番 ?? undefined,
      原動機有無フラグ: 原動機コード ?? undefined,
      メーカー: メーカーコード ?? undefined,
      車台番号: 車台番号 ?? undefined,
      廃車予定フラグ:
        廃車予定フラグ != null && !wjCore.isNullOrWhiteSpace(廃車予定フラグ) ? parseInt(廃車予定フラグ) : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TTenkenSeibiListGetReq) => {
    const disp部所 = 部所ItemSource?.find((i) => i.部所コード === searchCondition.部所コード)
    const disp原動機 = 原動機ItemSource?.find((i) => i.value === searchCondition.原動機有無フラグ)

    return {
      年: searchCondition.年,
      点検整備区分: !wjCore.isNullOrWhiteSpace(点検整備区分コード ?? "") ? "法令点検" : undefined,
      部所: disp部所 ? `${disp部所.部所コード} ${disp部所.部所略称}` : undefined,
      原動機: disp原動機 ? `${disp原動機.name}` : undefined,
      車番: searchCondition.車番,
      メーカー: searchCondition.メーカー,
      車台番号: searchCondition.車台番号,
      廃車予定: 廃車予定リスト?.find((i) => i.value === searchCondition.廃車予定フラグ?.toString())?.name,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    disPatch(clearAlert())
  }

  const clearSearchState = () => {
    set年(parseInt(dayjs(eigyobi).format("YYYY")))
    ref明細フォーマットフラグ.current = false
    ref年度.current = parseInt(dayjs(eigyobi).format("YYYY"))

    set車番("")
    setメーカーコード("")
    set車台番号("")
    // setDisp点検整備区分("")

    set部所コード("")
    set部所(undefined)
    // set部所ItemSource(undefined)
    set原動機コード(undefined)
    set原動機(undefined)
    // set原動機ItemSource(undefined)
    set点検整備区分コード("")
    set点検整備区分(undefined)
    set廃車予定フラグ("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // 12ヵ月×予定&実績の分
    const cnt = 24

    // カレンダー部分以外の設定
    columnHeaders.columns.forEach((c, index) => {
      if (!c.binding?.includes("月_")) {
        columnHeaders.setCellData(0, index, c.header)
      }
      // 予定月、実績月に対応
      for (let i = 1; i < cnt + 1; i++) {
        let month = "月_" + i
        if (c.binding?.includes(month)) {
          columnHeaders.setCellData(0, index, i + "月")
          if (c.binding?.includes("予定")) {
            c.header = `${i}月予定`
            columnHeaders.setCellData(1, index, "予定")
          } else if (c.binding?.includes("実績")) {
            c.header = `${i}月実績`
            columnHeaders.setCellData(1, index, "実績")
          }
          c.align = "center"
        }
      }
      c.allowMerging = true
    })

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)

    // カレンダー部分のクリックイベントを設定する
    grid.addEventListener(grid.hostElement, "click", (e: number | wjCore.Point | MouseEvent | HTMLElement) => {
      // 指定ポイントの情報を取得
      let ht = grid.hitTest(e)

      // カレンダー列かつ通常セル部分のみ編集処理を設定する。
      if (ht.col > 8 && ht.cellType === 1) {
        // 選択箇所の行データを取得する
        const rItem: T点検整備Item = grid.selectedItems[0]

        // 選択箇所のBind名を取得し、月を抽出する
        const cBindingItem = grid.columnHeaders.columns[ht.col].binding
        const colNum = cBindingItem?.substring(cBindingItem.indexOf(`_`) + 1) ?? ("" as unknown as MonthNumber)

        // 日付を設定
        let dayString = ref年度.current.toString() + "/" + ("00" + colNum).slice(-2) + "/01"

        // 編集対象の点検整備ItemList
        const targetItemList: TSyaryoTenkenList[] = []

        // 選択列の年月範囲か判定
        rItem.点検整備リスト.forEach((item: TSyaryoTenkenList) => {
          const yotei = dayjs(item.点検整備予定日).format("YYYY/MM")
          const zissi = dayjs(item.点検整備実施日).format("YYYY/MM")

          // 予定日か実績日のいずれかが年月範囲なら編集対象とする。
          if (dayjs(dayString).isSame(yotei) || dayjs(dayString).isSame(zissi)) {
            targetItemList.push(item)
          }
        })

        const 点検整備区分コード = (rItem as any)[`初期表示用予定点検整備区分コード_${colNum}`] as string | undefined

        // 必要なState設定して編集Modalを表示
        set車輌ID(rItem.車輌ID)
        // TODO: 編集モーダル初期値用に年月セット
        setCol予定年月(dayString)
        set点検整備リスト(targetItemList)
        set初期表示用点検整備区分コード(点検整備区分コード)
        // set車番(rItem.車番)
        setSearchModal車番(rItem.車番)
        set部所名(rItem.部所名)
        setIsTenkenListModalShow(true)
      }
    })

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // 12ヵ月×予定&実績の分
    const cnt = 24

    // 背景色設定
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      const rowData: T点検整備Item = e.getRow().dataItem
      if (!rowData) return

      // カレンダー列のBind名を確認しながら、予定日or実施日が複数ある場合に色変更
      // 1~12月分
      for (let i = 1; i < cnt + 1; i++) {
        let yoteiMonth = "予定月_" + i
        let zissiMonth = "実績月_" + i
        // 予定月の判定
        if (cellBinding === yoteiMonth || cellBinding === zissiMonth) {
          // データが存在する場合 リンクテキスト風にcssをあてる
          if (e.cell.innerHTML !== "") {
            wjCore.toggleClass(e.cell, "link-text", true)
          }
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年, set年] = useState<number>(parseInt(dayjs(eigyobi).format("YYYY")))
  const [col予定年月, setCol予定年月] = useState<string>()

  // Modal渡す用
  const [searchModal車番, setSearchModal車番] = useState<string>()
  // 検索項目用
  const [車番, set車番] = useState<string>()
  const [車台番号, set車台番号] = useState<string>()

  const [disp点検整備区分, setDisp点検整備区分] = useState<string>()

  // modal用
  const [車輌ID, set車輌ID] = useState<number>()
  const [部所名, set部所名] = useState<string>()
  const [初期表示用点検整備区分コード, set初期表示用点検整備区分コード] = useState<string>()
  const [点検整備リスト, set点検整備リスト] = useState<TSyaryoTenkenList[]>()

  //modal
  const [isTenkenListModalShow, setIsTenkenListModalShow] = useState<boolean>(false)
  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] = useState<TTenkenSeibiListGetReq>({} as TTenkenSeibiListGetReq)

  //#region comboboxState
  // メーカー
  const [メーカーコード, setメーカーコード] = useState<string | null>()
  const [メーカーComboBox, setメーカーComboBox] = useState<TWijmoComboBox<string, T支払先> | null>(null)
  const [メーカーisLoadEnded, setメーカーisLoadEnded] = useState<boolean>(false)
  const [支払先ItemSource, set支払先ItemSource] = useState<T支払先[]>()

  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<T部所マスタ["部所コード"], T部所マスタ> | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  // 原動機
  const [原動機コード, set原動機コード] = useState<number>()
  const [, set原動機] = useState<T原動機 | null>()
  const [原動機ComboBox, set原動機ComboBox] = useState<TWijmoComboBox<number, T原動機> | null>(null)
  const [原動機IsLoadEnded, set原動機IsLoadEnded] = useState<boolean>(false)
  const [原動機ItemSource, set原動機ItemSource] = useState<T原動機[]>()

  // 点検整備区分
  const [点検整備区分コード, set点検整備区分コード] = useState<string | null>()
  const [, set点検整備区分] = useState<T区分マスタ | null>()
  const [点検整備区分ItemSource, set点検整備区分ItemSource] = useState<T区分マスタ[]>()
  const [点検整備区分ComboBox, set点検整備区分ComboBox] = useState<TWijmoComboBox<string, TItem> | null>(null)
  const [点検整備区分IsLoadEnded, set点検整備区分IsLoadEnded] = useState<boolean>(false)
  // 廃車予定
  const [廃車予定フラグ, set廃車予定フラグ] = useState<string | null>(null)
  const [廃車予定ComboBox, set廃車予定ComboBox] = useState<TWijmoComboBox<number, TItem> | null>(null)
  const [廃車予定IsLoadEnded, set廃車予定IsLoadEnded] = useState<boolean>(false)
  const [廃車予定ItemSource, set廃車予定ItemSource] = useState<TItem[]>()

  //マスタ値取得制御
  const [pageDataInitialized, setPageDataInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  useEffect(() => {
    document.title = `点検整備一覧`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
  }, [])

  // TODO: APIから取得する
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SiharaisakiService().getList({
        支払先区分コード: e支払先区分.メーカー,
      }),
    ]).then(([部所ListRes, 区分マスタRes, メーカーマスタRes]) => {
      set部所ItemSource(部所ListRes?.data)
      set原動機ItemSource(boolList)
      set支払先ItemSource(メーカーマスタRes?.data)
      set廃車予定ItemSource(廃車予定リスト)

      if (!区分マスタRes?.data) {
        set点検整備区分ItemSource([])
        setDisp点検整備区分("")
      } else {
        const 点検整備区分List = 区分マスタRes.data?.filter((d) => d.分類コード === 区分分類コード.車輌.点検整備区分)
        set点検整備区分ItemSource(点検整備区分List)

        // 記号の注釈作成
        const 区分_法令点検_３ヶ月 = 点検整備区分List?.find((m) => m.区分コード === e点検整備区分.法令点検_３ヶ月)
        const 区分_法令点検_車検 = 点検整備区分List?.find((m) => m.区分コード === e点検整備区分.法令点検_車検)
        const 区分_事故修繕 = 点検整備区分List?.find((m) => m.区分コード === e点検整備区分.事故修繕)
        const 区分_整備 = 点検整備区分List?.find((m) => m.区分コード === e点検整備区分.整備)
        const 区分_自主点検 = 点検整備区分List?.find((m) => m.区分コード === e点検整備区分.自主点検)

        let dItem =
          e記号.丸 +
          区分_法令点検_３ヶ月?.名称2 +
          ":" +
          区分_法令点検_３ヶ月?.名称1 +
          " " +
          e記号.星 +
          区分_法令点検_車検?.名称2 +
          ":" +
          区分_法令点検_車検?.名称1 +
          " " +
          区分_事故修繕?.名称2 +
          ":" +
          区分_事故修繕?.名称1 +
          " " +
          区分_整備?.名称2 +
          ":" +
          区分_整備?.名称1 +
          " " +
          区分_自主点検?.名称2 +
          ":" +
          区分_自主点検?.名称1 +
          " ※ 白抜き記号は予定の候補日"
        setDisp点検整備区分(dItem)
        setPageDataInitialized(true)
      }
    })
  }, [])

  useEffect(() => {
    if (
      !メーカーisLoadEnded ||
      !部所IsLoadEnded ||
      !原動機IsLoadEnded ||
      !廃車予定IsLoadEnded ||
      !点検整備区分IsLoadEnded
    )
      return

    setComboDataInitialized(true)
  }, [メーカーisLoadEnded, 部所IsLoadEnded, 原動機IsLoadEnded, 点検整備区分IsLoadEnded, 廃車予定IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized && pageDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 初期値としてシステム年を設定
        set年(parseInt(dayjs(eigyobi).format("YYYY")))
        if (loginUser.運行部所フラグ === 1) {
          set部所コード(loginUser.部所コード)
        }
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized, pageDataInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">点検整備一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-70rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div>
                              <wjrInput.InputNumber
                                initialized={(control: wjcInput.InputNumber) => {
                                  control.inputElement?.focus()
                                }}
                                style={{ width: "5rem" }}
                                id="年"
                                name="年"
                                format={"g"}
                                focus
                                isRequired={true}
                                value={年}
                                valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                  c.value != null ? set年(c.value) : set年(parseInt(dayjs(eigyobi).format("YYYY")))
                                }}
                              />
                              &nbsp;年
                            </div>
                            <div>
                              <ComboBox.Default
                                className="max-w-15rem"
                                placeholder="点検整備"
                                isAllSelect={true}
                                itemsSource={点検整備区分ComboBox用リスト}
                                selectedValue={点検整備区分コード}
                                setSelectedValue={set点検整備区分コード}
                                isLoadEnded={点検整備区分IsLoadEnded}
                                setIsLoadEnded={set点検整備区分IsLoadEnded}
                                ComboBox={点検整備区分ComboBox}
                                setComboBox={set点検整備区分ComboBox}></ComboBox.Default>
                            </div>
                            <div className="w-10rem">
                              <ComboBox.Default
                                placeholder="原動機"
                                isAllSelect={true}
                                itemsSource={原動機ItemSource}
                                isLoadEnded={原動機IsLoadEnded}
                                setIsLoadEnded={set原動機IsLoadEnded}
                                setSelectedValue={set原動機コード}
                                selectedValue={原動機コード}
                                setSelectedItem={set原動機}
                                ComboBox={原動機ComboBox}
                                setComboBox={set原動機ComboBox}></ComboBox.Default>
                            </div>
                            <div>
                              <ComboBox.Busyo
                                placeholder="部所"
                                isAllSelect={true}
                                itemsSource={部所ItemSource}
                                isLoadEnded={部所IsLoadEnded}
                                setIsLoadEnded={set部所IsLoadEnded}
                                setSelectedValue={set部所コード}
                                selectedValue={部所コード}
                                setSelectedItem={set部所}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <div>
                              <TextInput
                                style={{ width: "5rem" }}
                                id="車番"
                                name="車番"
                                value={車番}
                                setValue={set車番}
                                maxLength={4}
                                placeholder="車番"
                              />
                            </div>
                            <div>
                              <ComboBox.SiharaiSaki
                                placeholder="メーカー車名"
                                siharaiSaki={e支払先区分.メーカー}
                                isLoadEnded={メーカーisLoadEnded}
                                setIsLoadEnded={setメーカーisLoadEnded}
                                isRequired={false}
                                isEmpty={true}
                                itemsSource={支払先ItemSource}
                                selectedValue={メーカーコード}
                                setSelectedValue={(v) => {
                                  setメーカーコード(v)
                                }}
                                ComboBox={メーカーComboBox}
                                setComboBox={setメーカーComboBox}></ComboBox.SiharaiSaki>
                            </div>
                            <div>
                              <TextInput
                                id="車台番号"
                                name="車台番号"
                                value={車台番号}
                                setValue={set車台番号}
                                placeholder="車台番号"
                              />
                            </div>
                            <div>
                              <ComboBox.Default
                                className="max-w-15rem"
                                placeholder="廃車車輌"
                                isAllSelect={true}
                                itemsSource={廃車予定ItemSource}
                                selectedValue={廃車予定フラグ}
                                setSelectedValue={set廃車予定フラグ}
                                isLoadEnded={廃車予定IsLoadEnded}
                                setIsLoadEnded={set廃車予定IsLoadEnded}
                                ComboBox={廃車予定ComboBox}
                                setComboBox={set廃車予定ComboBox}></ComboBox.Default>
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                beforeSearch()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel displaySearchCondition={displaySearchCondition} />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  excelFormatItem={tenkenseibiExcelFormat}
                  pdfFormatItem={tenkenseibiPdfFormat}
                  searchConditionClear={searchConditionClear}
                  gridId={`${gridId}_1`}
                  isRestoreSearching={isRestoreSearching}
                  gridItemsSourceChangedHandler={(grid) => {
                    commonUtil.customAutoExtendsColumns(grid, 9)
                    if (grid.itemsSource && wjCore.asCollectionView(grid.itemsSource)) {
                      const itemsSource = grid.itemsSource as wjCore.CollectionView
                      itemsSource.onPageChanged = (e) => {
                        commonUtil.customAutoExtendsColumns(grid, 9)
                      }
                    }
                  }}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  hasFilter={false}
                  headerComponent={
                    <span className="text-primary" style={{ marginLeft: "0.5rem" }}>
                      {disp点検整備区分}
                    </span>
                  }
                  gridProperties={{
                    frozenColumns: 6,
                    // allowSorting: wjcGrid.AllowSorting.None,
                    allowDragging: wjcGrid.AllowDragging.None,
                  }}>
                  <wjrGrid.FlexGridColumn binding="部所名" width={180} header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="車番" width={80} sortMemberPath="sort_車番" header="車番">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T点検整備Item>) => {
                        // 車輌マスタ登録
                        const url = util
                          .getMenuPath(メニューコード.車輌管理.車輌マスタ登録)[1]
                          ?.replaceAll(":id", `${context.item.車輌ID}`)
                        return wjCore.isNullOrWhiteSpace(url) ? (
                          <>{context.item.車番}</>
                        ) : (
                          <a
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(location.pathname)
                            }}
                            href={url}>
                            {context.item.車番}
                          </a>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="登録番号" width={150} header="登録番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="原動" width={40} header="原動">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T点検整備Item>) => {
                        let tmp = ""
                        if (context.item.原動機有無フラグ === 1) tmp = "有"
                        return <>{tmp}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="車検満了日" width={120} wordWrap={true} header="車検満了日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T点検整備Item>) => {
                        let dt = ""
                        if (context.item.車検満了日) dt = dayjs(context.item.車検満了日).format("YYYY/MM/DD")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="廃車予定年月" width={80} wordWrap={true} header="廃車予定">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T点検整備Item>) => {
                        let dt = ""
                        if (context.item.廃車予定年月) dt = dayjs(context.item.廃車予定年月).format("YYYY/MM")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  {/* ---列固定化--- */}

                  <wjrGrid.FlexGridColumn
                    binding="メーカー車名"
                    width={130}
                    header="メーカー車名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="車台番号" width={150} header="車台番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="社員氏名" width={130} header="乗務員"></wjrGrid.FlexGridColumn>

                  {/* カレンダー列 */}
                  <wjrGrid.FlexGridColumn binding="予定月_1" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_1" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_2" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_2" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_3" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_3" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_4" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_4" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_5" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_5" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_6" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_6" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_7" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_7" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_8" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_8" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_9" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_9" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_10" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_10" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_11" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_11" width={60} header="実績"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="予定月_12" width={60} header="予定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="実績月_12" width={60} header="実績"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 点検整備一覧Modal */}
        <TenkenSeibiListModal
          title="点検整備一覧"
          車輌ID={車輌ID!}
          予定年月={col予定年月}
          部所名={部所名 ?? ""}
          初期表示用点検整備区分コード={初期表示用点検整備区分コード ?? ""}
          点検整備List={点検整備リスト}
          車番={searchModal車番 ?? ""}
          isShow={isTenkenListModalShow}
          setIsShow={(v) => {
            setIsTenkenListModalShow(v)
          }}></TenkenSeibiListModal>
        {/* 点検整備モーダル */}
        {/* <TenkenSeibiModal
          title="点検整備入力"
          modalType="点検整備"
          isShow={isTenkenSeibi}
          setIsShow={setIsTenkenSeibi}
          changeStateFlg={isChangeStateFlg}
          setChangeStateFlg={setIsChangeStateFlg}
          車輌Id={`${gridId}_Modal_1`}
          // 車輌点検整備id={[1, 2]}
          // DateInput制御用の日付は、選択セルから生成する為、必ず存在する想定
          dateControlItem={ref月.current!}></TenkenSeibiModal> */}
      </FunctionContext.Provider>
    </Container>
  )
}

export default TenkenSeibiList

const 点検整備区分ComboBox用リスト: TItem[] = [
  {
    name: "法令点検",
    value: "1",
  },
]

// バックエンド側はValueの値により処理分岐させる
const 廃車予定リスト: TItem[] = [
  {
    name: "廃車車輌（すべて）",
    value: "1",
  },
  {
    name: "廃車（保管あり）",
    value: "2",
  },
  {
    name: "廃車（保管なし）",
    value: "3",
  },
  {
    name: "廃車除く",
    value: "4",
  },
]
